import React from 'react';
import PropTypes from 'prop-types';
import styles from './SearchResultItem.module.scss';
import { serializeImage } from '../../utils/SerializeImage';
import BackgroundImage from '../BackgroundImage';
import { useContextState } from '../StateProvider';
import classNames from 'classnames';

const SearchResultItem = ({ title = '', text = '', image = {}, href = '', categories = [] }) => {
    const [{ view, fromMap } = {}] = useContextState();
    const serializedImage = serializeImage(image);

    categories = categories ? categories.join(' / ') : '';
    const isGrid = view === 'grid' || view === undefined || view === 'undefined';

    const sizes =
        '(min-width: 1440px) 297px, (min-width: 1280px) 267px, (min-width: 1024px) 212px, (min-width: 768px) 162px, 50vw';

    const classes = classNames(styles['SearchResultItem'], {
        [styles['SearchResultItem--List']]: view === 'list',
        [styles['SearchResultItem--Grid']]: isGrid,
    });

    // remove protocol from url
    const urlWithoutProtocol = href.replace(/(^\w+:|^)\/\//, '');
    let urlParts = urlWithoutProtocol.split('/').splice(1);
    urlParts.pop(); // remove last item in array which is an empty string
    urlParts.pop(); // remove last item in array which the title
    const prettyUrl = urlParts.join(' / ');

    let linkProps = {};

    if (fromMap) {
        href = href + '?from_map=true';
        // To make sure google doesn't index pages with query params
        linkProps.rel = 'nofollow';
    }

    const stripAllTags = (text) => {
        return text.replace(/(<([^>]+)>)/gi, '').replaceAll('.', '. ');
    };

    return (
        <article className={classes}>
            <a href={href} {...linkProps} className={styles['SearchResultItem__Link']}>
                <span className="sr-only">{title}</span>
            </a>
            <div className={styles['SearchResultItem__Image']}>
                {serializedImage && <BackgroundImage {...serializedImage} quality={60} sizes={sizes} />}
            </div>
            <div className={styles['SearchResultItem__ItemContent']}>
                <h3 className={styles['SearchResultItem__Title']}>{title}</h3>
                {!isGrid && (
                    <span aria-hidden={true} className={styles['SearchResultItem__Url']}>
                        {prettyUrl}
                    </span>
                )}
                <p
                    className={styles['SearchResultItem__Preamble']}
                    dangerouslySetInnerHTML={{
                        __html: stripAllTags(text),
                    }}></p>
                {isGrid && <span className={styles['SearchResultItem__Category']}>{categories}</span>}
            </div>
        </article>
    );
};

SearchResultItem.propTypes = {
    title: PropTypes.string,
    href: PropTypes.string,
    text: PropTypes.string,
    categories: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    image: PropTypes.object,
};

export default SearchResultItem;
